import axios from "./axios";
import { useNavigate } from "react-router";
// const navigate = useNavigate()
const API = async ({
  url,
  method,
  responseType,
  data,
  cancelToken,
  params,
  headers,
  onUploadProgress
}) => {
  let axiosRequestObject = {
    method,
    url,
    data,
    headers,
    responseType,
    params,
    ...(cancelToken
      ? {
        cancelToken,
      }
      : ""),
    onUploadProgress
  };

  //REQUEST
  try {
    let request = await axios.request(axiosRequestObject);
    return request.data;
  } catch (err) {
    if (err.response?.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    localStorage.removeItem("expiry");
    localStorage.removeItem("show");
    localStorage.removeItem("salesTabFlag");
    localStorage.removeItem("type");
    localStorage.removeItem("discount-obj");
    localStorage.removeItem("main_user");
    localStorage.removeItem("selectedSalesList");
    localStorage.removeItem("discount-obj")
    localStorage.removeItem("slot-id")
    localStorage.removeItem("sales_team")
    localStorage.removeItem("reduxState")
    }
    if (!err.response) {
      return Promise.reject(err)
    }
    else return err.response
  }
};

export default API